export enum TransportOptionType {
    /**
     * None
     */
    None = 0,
    /**
     * Truck
     */
    Truck = 1,
    /**
     * Container
     */
    Container = 2,
    /**
     * Freight Trailer
     */
    FreightTrailer = 3,
    /**
     * Trailer (not freight)
     */
    Trailer = 4,
    TruckSizeRange = 5,
    /**
     * Auto Shipping
     */
    AutoShipping = 6,
    /**
     * ReloCube
     */
    ReloCube = 7,
}

const transportOptionTypeDescription = {
    None: 'None',
    Truck: 'Truck',
    Container: 'Container',
    FreightTrailer: 'Freight Trailer',
    Trailer: 'Trailer (not freight)',
    TruckSizeRange: 'Truck Size Range',
    AutoShipping: 'Auto Shipping',
    ReloCube: 'ReloCube',
};

export const TransportOptionTypeDescription = {
    ...transportOptionTypeDescription,

    get: (value: TransportOptionType | undefined | null): string | undefined => {
        if (typeof (value) === "string") {
            return transportOptionTypeDescription[value];
        }
        if (value===null || value===undefined) {
            return undefined;
        }
        return transportOptionTypeDescription[TransportOptionType[value]  as keyof typeof transportOptionTypeDescription];
    },
    all: [
        { value: 0, label: transportOptionTypeDescription.None },
        { value: 1, label: transportOptionTypeDescription.Truck },
        { value: 2, label: transportOptionTypeDescription.Container },
        { value: 3, label: transportOptionTypeDescription.FreightTrailer },
        { value: 4, label: transportOptionTypeDescription.Trailer },
        { value: 5, label: transportOptionTypeDescription.TruckSizeRange },
        { value: 6, label: transportOptionTypeDescription.AutoShipping },
        { value: 7, label: transportOptionTypeDescription.ReloCube },
    ] as ReadonlyArray<{label: string, value: number}>
};
